/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerFindOneQueryResponse, JobsControllerFindOnePathParams, JobsControllerFindOneQueryParams, JobsControllerFindOne400, JobsControllerFindOne401, JobsControllerFindOne403, JobsControllerFindOne404 } from "../../models/jobsController/JobsControllerFindOne";

function getJobsControllerFindOneUrl(id: JobsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/jobs/${id}` as const }  
  return res
}

/**
 * @summary Get a job by id
 * {@link /api/v1/jobs/:id}
 */
export async function jobsControllerFindOne(id: JobsControllerFindOnePathParams["id"], params?: JobsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerFindOneQueryResponse, ResponseErrorConfig<JobsControllerFindOne400 | JobsControllerFindOne401 | JobsControllerFindOne403 | JobsControllerFindOne404>, unknown>({ method : "GET", url : getJobsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}